// Что нового: список обновлений для игроков (не технический журнал коммитов — только то, что видно за столом).
// Новая запись — первой; её дата — «версия» ченджлога: увидев незнакомую, приложение кладёт в ящик
// уведомление «обновление» (если новости не отключены). Дата в формате ГГГГ-ММ-ДД; вторая запись за тот же
// день получает свой id — иначе версия не сменится и об обновлении никто не узнает.

export interface ChangelogEntry {
  date: string;
  /** версия записи, когда за день их больше одной (по умолчанию версия — дата) */
  id?: string;
  title: string;
  items: string[];
}

export const CHANGELOG: readonly ChangelogEntry[] = [
  {
    date: '2026-10-25',
    id: '2026-10-25-corr',
    title: 'Бокс по переписке',
    items: [
      'На главном экране — «✉️ Бокс по переписке»: партия с друзьями, которая идёт днями. Создай набор на 2–5 игроков, остальные входят из списка открытых партий или по ссылке, свободные места можно отдать ботам. Как только набрались все, партия начинается сама.',
      'Ходить можно, когда удобно: когда до тебя доходит очередь, приходит уведомление — выбрать жетон и фамильяра, взять третьего фамильяра из сброшенных, сделать ход или ответить на атаку. Тап по уведомлению открывает партию.',
      'Для игры по переписке нужны уведомления — включаются одной кнопкой. В профиле на вкладке «Устройства» видно, где они включены; там же их можно выключить или проверить. Уведомления приходят на все связанные устройства.',
      'Новость, которую ты уже прочитал в «Что нового», больше не висит непрочитанной в колокольчике. Так же прочитанными становятся ачивки, когда открыт профиль, и приглашение, когда ты вошёл в комнату.',
    ],
  },
  {
    date: '2026-10-25',
    title: 'Новый экран рейтингов',
    items: [
      'Рейтинги теперь начинаются с витрины «Выделяются»: у кого самая длинная серия побед, лучшая меткость, рекорд ★ за партию, больше всех побеждённых боссов, лучшая форма недели и больше всего партий. На каждой карточке видно и твоё место.',
      'Ниже — все номинации одним списком: лидер каждой и твоё место. Тап по строке открывает полную таблицу.',
      'Новая номинация «🎲 с мутаторами»: партии с мутаторами против сложных ботов и сильнее. С лёгкими и средними ботами мутаторы теперь идут в таблицу своего уровня. Уже сыгранные партии пересчитаны.',
      'Вечный зал сида дня — тоже среди номинаций рейтинга.',
    ],
  },
  {
    date: '2026-10-24',
    id: '2026-10-24-duels',
    title: 'Дуэль с боссом, мутаторы и коллекция боссов',
    items: [
      'На главном экране — «🥊 Дуэль с боссом»: один на один с любым из десяти боссов. Правило дуэли: в начале хода отстающий по очкам берёт карту, а отстающий на 10 ПО и больше — две. Вдвоём первая кровь больше не решает партию — отыграться можно до конца. В рейтингах — новая номинация «🥊 дуэли».',
      'Мутаторы теперь можно включить самому — в «Против ботов» и «Своей партии»: 🍔 Жирная рука, 🥚 Хрупкие колдуны, 🛍️ Богатая барахолка, 📦 Наследство, 🪜 Догоняющий и 🌪️ Беспредельный круг. Можно несколько сразу. Партии с мутаторами в таблицы не идут, но победы и ачивки засчитываются. Сид дня выбирает мутатор из пяти.',
      'В профиле — коллекция боссов: кого из десяти ты побеждал и сколько раз. Новые ачивки: серия «Охотник на боссов» (первый босс, пять разных и все десять), «Цареубийство», «Чистая дуэль» и «Мутант». Уже сыгранные партии с боссами и мутаторами тоже засчитаны.',
      'Боссы покупают с оглядкой на свою пассивку. Король Похоти подсовывает вялую палочку только тому, кто его обгоняет, а Бензорук получает чипсину только за первый удар в ход.',
    ],
  },
  {
    date: '2026-10-24',
    id: '2026-10-24-bosses',
    title: 'Боссы',
    items: [
      'Десять боссов — колдуны-планшеты из коробки: Нетотдед, Бензорук, Хрючево, Баба Катя, Яжмужик, Кимоняша, Танатыч, Король Похоти, Грибуль Дюк и Бедовая Принцесса. Босс — сложный бот с портретом, своим фамильяром, характером и одной пассивкой: Яжмужику легенды дешевле, Бензорук собирает чипсины с каждого удара, Танатыч догоняет лишней картой, Король Похоти подсовывает лидеру вялые палочки, Грибуль ест затравки с верха колоды… Тап по боссу за столом покажет его пассивку.',
      'В «Против ботов» переключатель «👑 Один из ботов — босс»: какой именно — решит сид партии. Сид дня каждый третий день сажает за стол босса.',
      'Сила боссов пристреляна ареной: каждый выигрывает у стола из трёх сложных ботов заметно чаще честной доли, но не всегда. Партии с боссом идут в отдельную номинацию рейтинга «👑 боссы» — уровни остальных ботов не важны.',
    ],
  },
  {
    date: '2026-10-24',
    title: 'Сид дня, зал славы и мутатор «Жирная рука»',
    items: [
      'На главном экране — «📅 Сид дня»: каждый день один стол на всех — тот же сид, те же три сложных бота с характерами и тот же мутатор дня. Одна попытка в день на аккаунт: начатая партия считается сыгранной, поэтому сначала выдохни, потом жми «Играть».',
      'Таблица дня: место по отрыву от лучшего бота (у проигравшего он отрицательный), при равенстве — по очкам. Вчерашняя таблица открывает записи партий для просмотра в плеере. Вечный зал славы считает выигранные дни.',
      'Мутаторы — изменения правил на одну партию. Первый: 🍔 «Жирная рука» — рука 6 карт вместо 5, партия короче и щедрее. Выпадает в сид дня через день с классикой; в партии значок мутатора в шапке стола — тап покажет, что изменено.',
      'Партии с мутатором в таблицы «против ботов» не идут (они несравнимы с обычными) — только в зал дня; классический сид дня зачитывается и там, и там.',
    ],
  },
  {
    date: '2026-10-12',
    title: 'Карты с добором играются только вручную',
    items: [
      'Автоматика больше не разыгрывает карты, которые добирают карты (Мозгоштурм, Бесопанки, Легендохранитель…): добор показывает тебе закрытые карты колоды, и после него «Отмена» невозможна. Раньше цепочка добора проглатывалась целиком — и уничтожить хлам с руки было уже нельзя.',
      'Теперь такая карта ждёт на руке: сначала можно нажать «Отмену» или уничтожить хлам, потом сыграть добор самому. Простые карты без добора по-прежнему играются сами. Работает и в начатых партиях.',
    ],
  },
  {
    date: '2026-10-09',
    id: '2026-10-09-holesterin',
    title: 'Смерть от холестерина и Дохляки',
    items: [
      'Дохляк на столе (Зак, Чак, Ермак, Жак, Исаак) считается жетоном дохлого колдуна — поэтому «Смерть от холестерина» при нём не даёт +7 мощи, даже если настоящих жетонов нет. Теперь карта говорит об этом в ленте, а не молчит.',
      'И раз Дохляк — жетон, «Смерть от холестерина» может его уничтожить, как и обычный жетон. Раньше в таком случае карта не делала ничего. Уже начатые партии доигрываются по-старому (объяснение в ленте — и в них).',
    ],
  },
  {
    date: '2026-10-09',
    id: '2026-10-09-undo-steps',
    title: '«Отмена» по шагам',
    items: [
      'Если после розыгрыша карты автоматика сыграла простые карты, первая «Отмена» возвращает в руку только их — сама карта остаётся на столе. Вторая «Отмена» вернёт и её.',
      'Так можно, например, сыграть тварь, вернуть сыгранное автоматикой и уничтожить хлам с руки Спиногрызогрызами, которым нужна вторая тварь. Раньше одна отмена откатывала всё разом, вместе с тварью.',
      'Работает и в партиях, начатых до обновления.',
    ],
  },
  {
    date: '2026-10-09',
    id: '2026-10-09-ach-fx',
    title: 'Ачивки: торжественное получение',
    items: [
      'Новая ачивка вылетает карточкой «Ачивка получена!» — с лучами, бликом, искрами и звуком; несколько новых показываются по очереди, а на экране итога партии появляются одна за другой.',
      'В профиле ачивки, полученные в этой сессии, мигают золотом с пометкой «новая!» и стоят первыми.',
    ],
  },
  {
    date: '2026-10-09',
    id: '2026-10-09-magolovka',
    title: 'Венерина маголовка: обмен статусом и жизнями',
    items: [
      'Исправлено: если лошара меняется «и тем и другим» с колдуном, у которого полное здоровье, жизни теперь меняются такими, какими были до обмена: бывший лошара получает 20, а новый лошара — его 15. Раньше новый лошара сначала срезался до 15, и обмен приносил всего 15.',
      'Уже начатые партии доигрываются по-старому.',
    ],
  },
  {
    date: '2026-10-09',
    id: '2026-10-09-ach',
    title: 'Ачивки и общая победа при полной ничьей',
    items: [
      'Ачивки: 76 штук — 16 разовых и 20 серий со ступенями — за яркие ходы и необычные победы — «Легендарный барыга», «Лошара-триумфатор», «Обратно в лицо», «Восстание из зада», «Сам себя ушатал» и другие. У серий по несколько ступеней: например, 3, 4 и 5 убийств за один ход. Пороги подобраны по сыгранным партиям: первая ступень — у каждой 5–20-й партии, последняя — реже одной на сотню.',
      'Ачивки даются в партиях рейтинга: против ботов в одиночку и онлайн. Все уже сыгранные партии тоже пересчитаны. Полученные ачивки — в профиле (👤 → «Партии»), там же список всех и как их получить. Новая ачивка приходит уведомлением и видна на экране итога партии.',
      'Полная ничья — поровну ПО, легенд и жетонов дохлых колдунов: правила на этот случай молчат, и раньше победа доставалась тому, кто раньше сидит за столом. Теперь победа засчитывается всем равным (и в рейтингах), за неё есть ачивка «Боевая ничья». Уже начатые партии доигрываются по-старому.',
    ],
  },
  {
    date: '2026-10-09',
    id: '2026-10-09-autodraw',
    title: 'Автоматика и уничтожение карт с руки',
    items: [
      'Если у тебя есть чем уничтожить карты с руки — «Волшебные отходы» на столе или «Спиногрызогрызы» (на руке или в игре со второй тварью), — карты с добором больше не разыгрываются сами. Простые карты по-прежнему играются автоматикой, а «Отмена» остаётся доступной: можно вернуть хлам в руку и уничтожить его. Карты с добором сыграй сам, когда закончишь.',
      'Раньше автоматика разыгрывала и добор, после него отмена пропадала, и уничтожить ненужное было уже нечем.',
      'Уже начатые партии доигрываются по-старому.',
    ],
  },
  {
    date: '2026-10-09',
    id: '2026-10-09-redirect',
    title: 'Главный приз за перенаправленную атаку',
    items: [
      'Исправлено: если ты перенаправил атаку обратно на атакующего (Сальный шут, Кондуктор Жми-На-Тормоза, Бензопила «Дружок») и он от неё подох, убийца — ты: главный приз Крутагидона переходит к тебе. Раньше это считалось самоубийством атакующего, и приз оставался у него.',
      'Уже начатые партии доигрываются по-старому.',
    ],
  },
  {
    date: '2026-10-09',
    title: 'Цирк братьев Лошашных и удвоенный штраф лошары',
    items: [
      'Исправлено: если у лошары есть и «Цирк братьев Лошашных», и жетон дохлого колдуна «удвой штрафные ПО за жетон лошары», Цирк теперь переворачивает весь удвоенный штраф: −10 становится +10. Раньше удвоенная половина оставалась штрафом и в сумме выходил ноль.',
      'Уже начатые партии доигрываются по-старому.',
    ],
  },
  {
    date: '2026-09-28',
    id: '2026-09-28-hand',
    title: 'Что известно о руке соперника',
    items: [
      'Карты, которые соперник взял на руку у всех на глазах (с барахолки через «Зад в будущее», из сброса, показанные эффектом, добранные известными с верха колоды), видны в его карточке — «Известно на руке», пока лежат у него на руке.',
      'Колода соперника пуста — значит, все его закрытые карты на руке, и карточка так и показывает: «Рука — колода пуста». Пустая рука — наоборот, всё в колоде.',
      'Исправлено: ряд карт в вопросе (например, в беспределе) не прокручивался влево, если карты не помещались, — первые были недоступны.',
    ],
  },
  {
    date: '2026-09-28',
    id: '2026-09-28-opponent',
    title: 'Колода соперника и счётчик онлайна',
    items: [
      'В карточке соперника состав его колоды теперь показан вместе с рукой — «Колода и рука». Раньше колода шла отдельно, и по ней можно было вычислить, что у соперника на руке.',
      'В онлайне этот состав тоже виден (раньше чужая колода там не показывалась вовсе). Что именно на руке — по-прежнему тайна.',
      'Счётчик онлайна считает от тебя: «Ты + 2 онлайн» или «Только ты онлайн».',
      'Новая иконка приложения теперь действительно доходит до всех: старую держал кэш офлайн-режима.',
    ],
  },
  {
    date: '2026-09-28',
    title: 'Зад в будущее и фамильяр',
    items: [
      'После «Зада в будущее» купленного своего фамильяра из-под планшета тоже можно сразу взять на руку — как карты с барахолки и шальную магию.',
    ],
  },
  {
    date: '2026-09-25',
    title: 'Автоматика ждёт при Волшебных отходах',
    items: [
      'Если на столе лежат Волшебные отходы, в начале хода карты больше не разыгрываются сами: сначала можно уничтожить ненужное с руки. Как только сыграешь первую карту (или активируешь отходы), автоматика доиграет остальное.',
      'Этот розыгрыш можно отменить кнопкой «Отмена» — все карты вернутся в руку, если при нём не добирались карты.',
    ],
  },
  {
    date: '2026-09-24',
    id: '2026-09-24-best',
    title: 'Лучшие партии в профиле',
    items: [
      'В профиле — «Лучшие партии»: игра, в которой набрано больше всего очков, в каждой номинации (против людей и против ботов каждого уровня). Тап — и она проиграется на столе.',
      'Проигранные партии теперь листаются страницами по 10 — видны все, а не только последние.',
      'Новая иконка приложения: кубок Крутагидона отреставрирован и вырезан без фона.',
    ],
  },
  {
    date: '2026-09-24',
    id: '2026-09-24-replays',
    title: 'Профили игроков и просмотр партий',
    items: [
      'Тапни строку в рейтинге — откроется профиль игрока: места во всех номинациях и его проигранные партии. Свой профиль — через плашку «👤» с именем в углу главного экрана или свою строку в таблице.',
      'Проигранную партию можно пересмотреть: она проигрывается на настоящем игровом столе глазами проигравшего, действие за действием — как ходят боты.',
      'Внизу — панель плеера: пауза, шаг вперёд и назад, переход к началу хода или к следующему ходу, ползунок перемотки и скорость 1×/2×/4×. Кнопка 📜 — журнал событий до текущего момента.',
      'В конце партии — итоговая таблица и «Разобрать партию»: где проигравший потерял очки по сравнению с ходом бота. Тап по ошибке из разбора — и стол перемотается к этому решению.',
      'Исправлено: с выложенным «Задом в будущее» купленную шальную магию теперь тоже можно взять на руку — стопка шальной магии часть барахолки. Уже начатые партии доигрываются по-старому.',
    ],
  },
  {
    date: '2026-09-24',
    id: '2026-09-24-ratings',
    title: 'Рейтинги и профиль',
    items: [
      'На главном экране — «🏆 Рейтинги»: таблицы лучших игроков в нескольких номинациях.',
      'Против ботов — отдельная таблица на каждый уровень: 🐣 лёгкие, 🤖 средние, 😎 сложные, 😈 нечестные. Считаются победы, рядом — число партий, процент побед и рекорд очков. Смешанный стол идёт по среднему уровню ботов.',
      'Против людей — рейтинг Эло по онлайн-партиям: растёт за каждого, кого ты обошёл по месту, и сильнее — если соперник сильнее тебя.',
      'На экране итога партии — как она сдвинула твоё место в таблице (а против людей — и рейтинг), и ссылка на таблицу.',
      'Уже сыгранные партии тоже вошли в таблицы.',
      'В зачёт идут партии, где ты один против ботов (с любого экрана), и онлайн-партии с людьми. Партии нескольких людей за одним телефоном и партии с ручными правками не считаются.',
      'Профиль — плашка «👤» в углу главного экрана: имя, под которым тебя видят в рейтингах и онлайне, и список твоих устройств.',
      'Играешь с телефона и компьютера? Свяжи устройства: на одном нажми «Показать код», на другом введи код или наведи камеру на QR. Партии со всех устройств пойдут в рейтинг одной строкой, а если на одном очистится браузер, результаты останутся на другом.',
    ],
  },
  {
    date: '2026-09-24',
    title: 'Новый главный экран и подготовка по правилам',
    items: [
      'Главный экран разобран: вместо длинной простыни — три крупных режима: «Против ботов», «Онлайн с друзьями» и «Своя партия».',
      '«Против ботов»: выбираешь, сколько соперников (1–4) и какого уровня, — и в бой, сразу к выбору жетона, без экрана «передай телефон». Выбор запоминается.',
      'Незаконченная партия — первой строкой на главном экране: «Продолжить». Новая партия поверх неё больше не затирает её молча — сначала спросим.',
      'Партия сохраняется с первой секунды: закрыл приложение посреди подготовки — продолжишь с того же места.',
      'Сначала выбирается жетон колдунского свойства, и только потом открываются два фамильяра на выбор — как в правилах игры (стр. 4). Раньше фамильяры были видны сразу, и жетон можно было подбирать под них.',
      'Жетон «три фамильяра» по-прежнему забирает обоих предложенных фамильяров сразу, третьего — из ничейных, когда выберут все.',
      'Уже начатые партии доигрываются по старому порядку.',
    ],
  },
  {
    date: '2026-09-11',
    title: 'Матчмейкинг и уведомления',
    items: [
      'На главном экране видно, кто сейчас онлайн и чем занят: в лобби, играет онлайн или за хотситом.',
      'Открытые комнаты — списком: создал комнату — её видят все, кто онлайн, и входят одной кнопкой. Хост может закрыть комнату, тогда вход только по коду.',
      'Позвать в игру: из лобби можно пригласить любого, кто онлайн, — даже если он сейчас играет хотсит. Приглашение приходит уведомлением с кнопкой «Войти».',
      'Ящик уведомлений 🔔: приглашения и новости об обновлениях. Новости можно отключить. Системные уведомления браузера — по разрешению, для приглашений, когда вкладка не на виду.',
      'Этот список «что нового» — на главном экране и в меню партии.',
      'Телефон: игровой экран перекроен под палец. В шапке одна кнопка меню (полный экран — в меню), мощь и чипсины — в строке статуса, вкладки во всю ширину и выше, плитки моей панели крупные и на всю ширину, «Конец хода» рядом с жизнями. Все кнопки не ниже 44 px — промахов меньше.',
      'Вопросы: карты на выбор не растягиваются в пустые полотна, в вопросе о защите текст карты идёт под плашкой во всю ширину. Экран «передай телефон» не растягивает короткую сводку на весь экран.',
    ],
  },
  {
    date: '2026-09-02',
    title: 'Версии правил',
    items: [
      'Партия играется по правилам той версии, на которой началась: обновление приложения не ломает сохранённую партию.',
      '«Шаг назад» в партии со старой версии честно объясняет, что действие сделано до обновления.',
      'Кнопка «Отмена» на экране хода плавает над панелью игрока, а не занимает место рядом с «Конец хода».',
    ],
  },
  {
    date: '2026-09-01',
    title: 'Шаг назад',
    items: [
      '↩ Отмена откатывает не только незавершённое действие, но и последнее завершённое действие своего хода — пока оно ничего не раскрыло.',
      'Отмена переживает закрытие приложения, возобновление партии и работает в онлайне; в меню видно, почему она недоступна.',
      'Режим ребаланса: волна 4 — правки жетонов свойств и верхушки карт по большим прогонам.',
    ],
  },
  {
    date: '2026-08-31',
    title: 'Уровни ботов',
    items: [
      'Четыре уровня бота: 🐣 лёгкий, 🤖 средний, 😎 сложный (честный) и 😈 нечестный (видит руки и колоды).',
      'В режиме ребаланса правленая карта показывает свои цену и текст и помечена ⚖; сравнить с обычными правилами можно, увеличив карту.',
      'Лошара воскресает с 15 жизнями (свой потолок), как по правилам.',
    ],
  },
  {
    date: '2026-08-29',
    title: 'Режим ребаланса в онлайне',
    items: [
      'Хост включает ⚖️ режим ребаланса в лобби; справка «что изменено» доступна всем.',
      'Справка ребаланса разбита на нерфы / баффы / переработку, тап по карте — полное описание с картинкой.',
    ],
  },
  {
    date: '2026-08-28',
    title: 'Характеры ботов и разбор партии',
    items: [
      'У ботов характеры: 🔥 агрессор, 💰 скупердяй, 🗡️ мстительный, 🤪 псих — и читаемые мотивы в журнале («мстит», «добивает»).',
      '🔍 Разбор после хотсит-партии: где решение человека проиграло ходу бота и на сколько очков.',
      'Боты в хотсите ходят мгновенно, перед твоим ходом — сжатая сводка событий.',
      'Нижняя панель — плитки-кнопки: очки с разбивкой, жетоны, колода и сброс по тапу.',
    ],
  },
];

/** Версия записи ченджлога: её id или дата */
export const changelogVersion = (e: ChangelogEntry): string => e.id ?? e.date;

/** Самая свежая запись; её версия — версия ченджлога */
export function latestChangelog(): ChangelogEntry {
  const e = CHANGELOG[0];
  if (!e) throw new Error('Пустой ченджлог');
  return e;
}

/** Дата по-русски: 2026-09-11 → 11 сентября 2026 */
export function fmtDate(iso: string): string {
  const m = iso.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return iso;
  const months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
  return `${Number(m[3])} ${months[Number(m[2]) - 1] ?? m[2]} ${m[1]}`;
}
